import { isNotEmptyStringOrWhiteSpace } from './stringOperation'

export const ROLES_FROM_LOWEST = ['guest', 'view', 'comment', 'copywrite', 'edit', 'admin'] as const
export type UserRole = (typeof ROLES_FROM_LOWEST)[number]

export function checkRole(params: { role: UserRole; minRequiredRole: UserRole }): boolean {
  if (
    !isNotEmptyStringOrWhiteSpace(params.role) ||
    !isNotEmptyStringOrWhiteSpace(params.minRequiredRole)
  ) {
    return false
  }

  const roleIndex = ROLES_FROM_LOWEST.findIndex(role => role === params.role)
  const minRoleIndex = ROLES_FROM_LOWEST.findIndex(role => role === params.minRequiredRole)

  return minRoleIndex <= roleIndex
}
